module.exports = __webpack_public_path__ + "img/4.f8db4d49.jpg";